(function () {
  'use strict';

  /* ---------- Animal prints (drawn once per page, cached) ---------- */
  var TAU = Math.PI * 2;
  function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function canvas(S) { var c = document.createElement('canvas'); c.width = c.height = S; return c; }
  function wrap(S, fn) { [-S, 0, S].forEach(function (dx) { [-S, 0, S].forEach(function (dy) { fn(dx, dy); }); }); }

  function leopard(o) {
    var S = 400, c = canvas(S), g = c.getContext('2d'), r = rng(o.seed), i;
    g.fillStyle = o.base; g.fillRect(0, 0, S, S);
    for (i = 0; i < 16; i++) {
      (function () {
        var x = r() * S, y = r() * S, rad = 60 + r() * 90, col = i % 2 ? o.light : o.dark;
        wrap(S, function (dx, dy) {
          var gr = g.createRadialGradient(x + dx, y + dy, 0, x + dx, y + dy, rad);
          gr.addColorStop(0, col); gr.addColorStop(1, 'rgba(0,0,0,0)');
          g.globalAlpha = .55; g.fillStyle = gr; g.fillRect(x + dx - rad, y + dy - rad, rad * 2, rad * 2); g.globalAlpha = 1;
        });
      })();
    }
    var n = 8, cell = S / n, ros = [], a, b;
    for (a = 0; a < n; a++) for (b = 0; b < n; b++) {
      ros.push({ x: (a + .5 + (r() - .5) * .7) * cell + (b % 2 ? cell * .3 : 0), y: (b + .5 + (r() - .5) * .7) * cell, rx: 10 + r() * 7, rot: r() * Math.PI, segs: 3 + Math.floor(r() * 3), a0: r() * TAU, seed: r() * 1e9 });
    }
    ros.forEach(function (q) { q.ry = q.rx * (.7 + r() * .3); });
    ros.forEach(function (q) {
      wrap(S, function (dx, dy) {
        var cx = q.x + dx, cy = q.y + dy;
        if (cx < -40 || cy < -40 || cx > S + 40 || cy > S + 40) return;
        g.save(); g.translate(cx, cy); g.rotate(q.rot);
        g.fillStyle = o.center; g.beginPath(); g.ellipse(0, 0, q.rx * .82, q.ry * .82, 0, 0, TAU); g.fill();
        g.strokeStyle = o.ink; g.lineCap = 'round';
        var step = TAU / q.segs, ang = q.a0, lr = rng(q.seed | 0), s;
        for (s = 0; s < q.segs; s++) {
          var span = step * (.55 + lr() * .3), w = 3.5 + lr() * 4;
          g.lineWidth = w; g.beginPath(); g.ellipse(0, 0, q.rx, q.ry, 0, ang, ang + span); g.stroke();
          g.lineWidth = w * .6; g.beginPath(); g.ellipse(lr() * 2 - 1, lr() * 2 - 1, q.rx + w * .3, q.ry + w * .3, 0, ang + span * .2, ang + span * .75); g.stroke();
          ang += step;
        }
        g.restore();
      });
    });
    g.fillStyle = o.ink;
    for (i = 0; i < 70; i++) {
      (function () {
        var sx = r() * S, sy = r() * S, sr = 1.6 + r() * 2.8, rot = r() * Math.PI;
        wrap(S, function (dx, dy) { g.beginPath(); g.ellipse(sx + dx, sy + dy, sr, sr * .7, rot, 0, TAU); g.fill(); });
      })();
    }
    return c.toDataURL('image/png');
  }
  function cheetah(base, ink, seed) {
    var S = 240, c = canvas(S), g = c.getContext('2d'), r = rng(seed), i;
    g.fillStyle = base; g.fillRect(0, 0, S, S); g.fillStyle = ink;
    for (i = 0; i < 62; i++) {
      (function () {
        var x = r() * S, y = r() * S, rad = 3 + r() * 6.5, rot = r() * Math.PI, ex = .65 + r() * .5, two = rad > 6.5;
        wrap(S, function (dx, dy) {
          g.beginPath(); g.ellipse(x + dx, y + dy, rad, rad * ex, rot, 0, TAU); g.fill();
          if (two) { g.beginPath(); g.ellipse(x + dx + rad * .7, y + dy + rad * .35, rad * .55, rad * .42, rot, 0, TAU); g.fill(); }
        });
      })();
    }
    return c.toDataURL('image/png');
  }
  function zebra(base, ink, seed) {
    var S = 240, c = canvas(S), g = c.getContext('2d'), r = rng(seed), N = 9, k;
    g.fillStyle = base; g.fillRect(0, 0, S, S); g.fillStyle = ink;
    for (k = 0; k < N; k++) {
      (function () {
        var y0 = k * S / N, ph = r() * TAU, ph2 = r() * TAU, f = 1 + Math.floor(r() * 2), A = 5 + r() * 8, T = 8 + r() * 6;
        [-S, 0, S].forEach(function (dy) {
          var x; g.beginPath();
          for (x = 0; x <= S; x += 4) { var yy = y0 + dy + A * Math.sin(x / S * TAU * f + ph); if (x === 0) g.moveTo(x, yy); else g.lineTo(x, yy); }
          for (x = S; x >= 0; x -= 4) { var t = T * (.55 + .45 * Math.sin(x / S * TAU * 2 + ph2)); g.lineTo(x, y0 + dy + A * Math.sin(x / S * TAU * f + ph) + Math.max(1.5, t)); }
          g.closePath(); g.fill();
        });
      })();
    }
    return c.toDataURL('image/png');
  }

  var RECIPES = {
    leo: function () { return leopard({ base: '#E2AE68', light: '#F3CF95', dark: '#C98A45', center: '#B56F2E', ink: '#24160D', seed: 7 }); },
    leoRose: function () { return leopard({ base: '#ECCBBE', light: '#F8E3DA', dark: '#DDAE9C', center: '#C68D79', ink: '#4E2A20', seed: 11 }); },
    cacao: function () { return leopard({ base: '#94603C', light: '#B07A52', dark: '#7A4C2E', center: '#5F391F', ink: '#1A0F08', seed: 21 }); },
    snow: function () { return leopard({ base: '#EAE7E2', light: '#FFFFFF', dark: '#D6D2CB', center: '#C4BEB5', ink: '#35312D', seed: 33 }); },
    cheetah: function () { return cheetah('#DDB27E', '#2B1D14', 5); },
    zebra: function () { return zebra('#F3EEE7', '#1E1915', 3); }
  };
  var cache = {};
  function printUrl(key) {
    if (!RECIPES[key]) key = 'leo';
    if (!cache[key]) {
      try { cache[key] = RECIPES[key](); } catch (e) { cache[key] = ''; }
    }
    return cache[key];
  }

  function applyPrints(root) {
    root.querySelectorAll('[data-print]').forEach(function (el) {
      if (el.hasAttribute('data-print-fixed')) return;
      var u = printUrl(el.getAttribute('data-print'));
      if (u) el.style.backgroundImage = 'url(' + u + ')';
    });
    root.querySelectorAll('[data-print-hover]').forEach(function (el) {
      var u = printUrl(el.getAttribute('data-print-hover'));
      if (u) el.style.setProperty('--tex', 'url(' + u + ')');
    });
  }

  /* ---------- Money + toast + cart count ---------- */
  function money(cents) {
    var fmt = (window.NX && NX.moneyFormat) || '£{{amount}}';
    var v = (cents / 100);
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = v.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var comma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return comma;
      return amount;
    });
  }
  var toastTimer;
  function toast(msg, isError) {
    var t = document.getElementById('nx-toast'), m = document.getElementById('nx-toast-msg');
    if (!t || !m) return;
    m.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3600);
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = n;
      c.classList.add('bump');
      setTimeout(function () { c.classList.remove('bump'); }, 300);
    });
  }
  function updateShipBars(total) {
    document.querySelectorAll('[data-ship-bar]').forEach(function (bar) {
      var th = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      if (!th) return;
      var left = th - total, msg = bar.querySelector('[data-ship-msg]'), fill = bar.querySelector('[data-ship-fill]');
      if (msg) msg.innerHTML = left > 0 ? 'You are <b>' + money(left) + '</b> away from free UK delivery' : 'Your basket qualifies for <b>free UK delivery</b>';
      if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / th)) + '%';
    });
  }
  function addToCart(id, qty, props) {
    var item = { id: Number(id), quantity: qty || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    return fetch(NX.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket');
        return fetch(NX.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.json(); });
      });
    }).then(function (cart) { setCount(cart.item_count); updateShipBars(cart.total_price); return cart; });
  }

  /* ---------- Quick add on product cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.disabled) return;
    b.classList.add('is-loading');
    addToCart(b.getAttribute('data-add'), 1)
      .then(function () { toast('Added to basket · ' + b.getAttribute('data-name') + ', size ' + b.getAttribute('data-size')); })
      .catch(function (err) { toast(err.message, true); })
      .then(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- Hero ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-hero]').forEach(function (hero) {
      var arch = hero.querySelector('[data-hero-arch]');
      hero.querySelectorAll('[data-pick]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-pick');
          hero.querySelectorAll('[data-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
          hero.querySelectorAll('[data-hero-item]').forEach(function (s) {
            var on = s.getAttribute('data-hero-item') === i;
            s.hidden = !on;
            if (on) { s.classList.remove('pop'); void s.offsetWidth; s.classList.add('pop'); }
          });
          hero.querySelectorAll('[data-now]').forEach(function (n) { n.hidden = n.getAttribute('data-now') !== i; });
          if (arch && !arch.hasAttribute('data-print-fixed')) {
            var u = printUrl(btn.getAttribute('data-pick-print'));
            if (u) arch.style.backgroundImage = 'url(' + u + ')';
          }
        });
      });
      var stage = hero.querySelector('[data-stage]');
      if (!stage || !arch || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(hover: hover)').matches) return;
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        arch.style.backgroundPosition = (x * -24) + 'px ' + (y * -24) + 'px';
        var shoe = hero.querySelector('[data-hero-item]:not([hidden])');
        if (shoe) shoe.style.transform = 'rotate(' + (-6 + x * 8) + 'deg) translate(' + (x * 16) + 'px,' + (y * 12) + 'px)';
      });
      stage.addEventListener('mouseleave', function () {
        arch.style.backgroundPosition = '';
        hero.querySelectorAll('[data-hero-item]').forEach(function (s) { s.style.transform = ''; });
      });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-pdp]').forEach(function (pdp) {
      var dataEl = pdp.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var cfg = JSON.parse(pdp.querySelector('[data-pdp-config]').textContent);
      var form = pdp.querySelector('form.pdp-form');
      var idInput = pdp.querySelector('[data-variant-id]');
      var atc = pdp.querySelector('[data-atc]');
      var atcLabel = pdp.querySelector('[data-atc-label]');
      var errEl = pdp.querySelector('[data-form-error]');
      var stock = pdp.querySelector('[data-stock]');
      var stockN = pdp.querySelector('[data-stock-n]');
      var fieldsets = Array.prototype.slice.call(pdp.querySelectorAll('[data-opt]'));
      var sticky = pdp.querySelector('[data-sticky-atc]');
      var stickyBtn = pdp.querySelector('[data-sticky-btn]');
      var stickyPrice = pdp.querySelector('[data-sticky-price]');
      var gallery = pdp.querySelector('[data-gallery]');
      if (!form || !idInput || !atc) return;

      function selected() {
        return fieldsets.map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function findVariant(sel) {
        if (sel.indexOf(null) > -1) return null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(sel) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input[type=radio]').forEach(function (inp) {
            var test = sel.slice(); test[idx] = inp.value;
            var any = variants.some(function (v) {
              for (var j = 0; j < test.length; j++) { if (test[j] !== null && v.options[j] !== test[j]) return false; }
              return v.available;
            });
            var label = fs.querySelector('label[for="' + inp.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !any);
          });
        });
      }
      function update(scrollToMedia) {
        var sel = selected();
        fieldsets.forEach(function (fs, i) {
          var b = fs.querySelector('[data-opt-value]');
          if (b) b.textContent = sel[i] || 'Select';
          if (sel[i]) fs.classList.remove('needs-attention');
        });
        markAvailability(sel);
        var v = findVariant(sel);
        errEl.hidden = true;
        if (!v) {
          idInput.value = '';
          var missing = sel.indexOf(null) > -1;
          atc.disabled = !missing;
          atcLabel.textContent = missing ? 'Select your size' : 'Unavailable';
          if (stickyBtn) stickyBtn.textContent = missing ? 'Select size' : 'Unavailable';
          if (stock) stock.hidden = true;
          return;
        }
        idInput.value = v.id;
        var atcPrice = pdp.querySelector('[data-atc-price]');
        if (atcPrice) atcPrice.textContent = '· ' + money(v.price);
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? 'Add to basket' : 'Sold out';
        if (stickyBtn) { stickyBtn.textContent = v.available ? 'Add to basket' : 'Sold out'; stickyBtn.disabled = !v.available; }
        var priceEl = pdp.querySelector('.pdp-price [data-amount]');
        if (priceEl) priceEl.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var cmp = pdp.querySelector('.pdp-price [data-compare]');
        var save = pdp.querySelector('[data-save]');
        if (v.compare > v.price) {
          if (!cmp) { cmp = document.createElement('s'); cmp.setAttribute('data-compare', ''); priceEl.parentNode.insertBefore(cmp, priceEl); }
          cmp.textContent = money(v.compare); cmp.hidden = false;
          if (save) { save.textContent = 'Save ' + money(v.compare - v.price); save.hidden = false; }
        } else {
          if (cmp) cmp.hidden = true;
          if (save) save.hidden = true;
        }
        if (stock) {
          var low = v.tracked && v.qty > 0 && v.qty <= cfg.low;
          stock.hidden = !low;
          if (low && stockN) stockN.textContent = v.qty;
        }
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (scrollToMedia && v.media && gallery) {
          var slide = gallery.querySelector('[data-media-id="' + v.media + '"]');
          if (slide) {
            var isRow = getComputedStyle(gallery).display === 'flex';
            if (isRow) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft - 16, behavior: 'smooth' });
            slide.classList.remove('is-flash'); void slide.offsetWidth; slide.classList.add('is-flash');
          }
        }
      }
      var colourIdx = gallery && gallery.hasAttribute('data-colour-index') ? parseInt(gallery.getAttribute('data-colour-index'), 10) : -1;
      function filterGallery() {
        if (!gallery) return;
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pdp-slide'));
        var colour = colourIdx >= 0 ? selected()[colourIdx] : null;
        var anyMatch = colour && slides.some(function (s) { return s.getAttribute('data-colour') === colour; });
        var visible = [];
        slides.forEach(function (s) {
          var show = !anyMatch || s.getAttribute('data-colour') === colour;
          s.hidden = !show; s.classList.remove('lead');
          if (show) visible.push(s);
        });
        if (visible[0]) visible[0].classList.add('lead');
        var dotsEl = pdp.querySelector('[data-dots]');
        if (dotsEl) {
          dotsEl.innerHTML = visible.map(function (_, i) { return '<span' + (i === 0 ? ' class="on"' : '') + '></span>'; }).join('');
          dotsEl.hidden = visible.length < 2;
        }
        gallery.scrollLeft = 0;
      }
      var packFs = pdp.querySelector('[data-pack-opt]');
      var packIdx = packFs ? parseInt(packFs.getAttribute('data-opt'), 10) : -1;
      var sizeIdx = -1;
      fieldsets.forEach(function (fs, i) { if (fs.hasAttribute('data-size-opt')) sizeIdx = i; });
      function pairsSelected() {
        if (!packFs) return 1;
        var c = packFs.querySelector('input[type=radio]:checked');
        return c ? (parseInt(c.getAttribute('data-pairs'), 10) || 1) : 1;
      }
      function looseVariant(test) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < test.length; j++) { if (test[j] !== null && v.options[j] !== test[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function refreshPack() {
        if (!packFs) return;
        var n = pairsSelected(), sel = selected(), unit = null;
        var box = packFs.querySelector('[data-extra-pairs]');
        if (box) box.hidden = n < 2;
        packFs.querySelectorAll('[data-pair]').forEach(function (el) { el.hidden = parseInt(el.getAttribute('data-pair'), 10) > n; });
        packFs.querySelectorAll('input[type=radio]').forEach(function (inp, i) {
          var test = sel.slice(); test[packIdx] = inp.value;
          var v = looseVariant(test); if (!v) return;
          if (i === 0) unit = v.price;
          var pairs = parseInt(inp.getAttribute('data-pairs'), 10) || 1;
          var q = '"' + inp.value.replace(/"/g, '\\"') + '"';
          var t = packFs.querySelector('[data-pack-total=' + q + ']'); if (t) t.textContent = money(v.price);
          var f = packFs.querySelector('[data-pack-full=' + q + ']'); if (f && unit) f.textContent = money(unit * pairs);
          var s = packFs.querySelector('[data-pack-save=' + q + ']');
          if (s && unit && pairs > 1) s.textContent = 'Save ' + money(unit * pairs - v.price) + ' · mix any styles';
          if (inp.checked) {
            var ap = pdp.querySelector('[data-atc-price]'); if (ap) ap.textContent = '· ' + money(v.price);
            var pa = pdp.querySelector('.pdp-price [data-amount]'); if (pa) pa.textContent = money(v.price);
            if (stickyPrice) stickyPrice.textContent = money(v.price);
          }
        });
      }
      function extraProps() {
        var out = { props: {}, missing: null }, n = pairsSelected();
        if (!packFs || n < 2) return out;
        var sel = selected();
        function desc(c, s) { return [c, s ? 'UK ' + s : null].filter(Boolean).join(' / '); }
        out.props['Pair 1'] = desc(cfg.title + (colourIdx >= 0 && sel[colourIdx] ? ' – ' + sel[colourIdx] : ''), sizeIdx >= 0 ? sel[sizeIdx] : null);
        packFs.querySelectorAll('[data-pair]').forEach(function (el) {
          var k = parseInt(el.getAttribute('data-pair'), 10); if (k > n) return;
          var c = el.querySelector('[data-extra-colour]'), s = el.querySelector('[data-extra-size]');
          if (s) s.classList.remove('is-missing');
          if (s && !s.value && !out.missing) out.missing = s;
          out.props['Pair ' + k] = desc(c ? c.value : null, s ? s.value : null);
        });
        return out;
      }
      if (packFs) packFs.addEventListener('click', function (e) {
        var chip = e.target.closest('.style-chip');
        if (!chip) return;
        var pair = chip.closest('[data-pair]');
        pair.querySelectorAll('.style-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === chip ? 'true' : 'false'); });
        var sel = pair.querySelector('[data-extra-colour]');
        if (sel) sel.value = chip.getAttribute('data-style-value');
      });
      if (packFs) packFs.addEventListener('change', function (e) {
        if (e.target && e.target.matches('select')) { e.target.classList.remove('is-missing'); errEl.hidden = true; }
      });
      fieldsets.forEach(function (fs, idx) {
        fs.addEventListener('change', function (e) {
          if (e.target && e.target.matches('select')) return;
          if (idx === colourIdx) filterGallery();
          update(false);
          refreshPack();
        });
      });
      refreshPack();
      filterGallery();

      function needSize() {
        var missing = fieldsets.filter(function (fs) { return !fs.querySelector('input:checked'); });
        if (!missing.length) return false;
        missing.forEach(function (fs) { fs.classList.remove('needs-attention'); void fs.offsetWidth; fs.classList.add('needs-attention'); });
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (needSize()) return;
        if (!idInput.value) return;
        atc.disabled = true;
        var prev = atcLabel.textContent;
        atcLabel.textContent = 'Adding…';
        var ex = extraProps();
        if (ex.missing) {
          ex.missing.classList.add('is-missing');
          ex.missing.focus();
          errEl.textContent = 'Choose the size for every pair in your pack.';
          errEl.hidden = false;
          atc.disabled = false;
          atcLabel.textContent = prev;
          return;
        }
        addToCart(idInput.value, 1, ex.props)
          .then(function () {
            var sel = selected().filter(Boolean).join(' / ');
            toast('Added to basket · ' + cfg.title + (sel ? ' (' + sel + ')' : ''));
          })
          .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
          .then(function () { atc.disabled = false; atcLabel.textContent = prev === 'Adding…' ? 'Add to basket' : prev; });
      });

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (needSize()) return;
          if (form.requestSubmit) form.requestSubmit(); else atc.click();
        });
      }
      if (sticky) {
        var ticking = false;
        var checkSticky = function () {
          ticking = false;
          sticky.hidden = atc.getBoundingClientRect().bottom > 0;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); }
        }, { passive: true });
        checkSticky();
      }

      var sizeBtn = pdp.querySelector('[data-open-size]');
      var sizePanel = pdp.querySelector('[data-size-panel]');
      if (sizeBtn && sizePanel) sizeBtn.addEventListener('click', function () {
        sizePanel.open = true;
        sizePanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      var dots = pdp.querySelector('[data-dots]');
      if (gallery && dots) {
        gallery.addEventListener('scroll', function () {
          var ds = dots.children;
          var first = gallery.querySelector('.pdp-slide:not([hidden])');
          if (!first || !ds.length) return;
          var w = first.getBoundingClientRect().width + 10;
          var i = Math.min(ds.length - 1, Math.round(gallery.scrollLeft / w));
          for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('on', k === i);
        }, { passive: true });
      }

      var lb = pdp.querySelector('[data-lightbox]');
      if (lb && lb.showModal) {
        var lbImg = lb.querySelector('[data-lightbox-img]');
        pdp.querySelectorAll('[data-zoom]').forEach(function (z) {
          z.addEventListener('click', function () {
            if (window.matchMedia('(max-width: 989px)').matches && gallery.scrollWidth > gallery.clientWidth + 5 && z.dataset.dragged) return;
            lbImg.src = z.getAttribute('data-zoom'); lbImg.alt = (z.querySelector('img') || {}).alt || ''; lb.showModal();
          });
        });
        lb.querySelector('[data-lightbox-close]').addEventListener('click', function () { lb.close(); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      }

      markAvailability(selected());

      var rev = document.getElementById('reviews');
      var media = pdp.querySelector('.pdp-media');
      if (rev && media && window.matchMedia('(min-width: 990px)').matches) {
        rev.classList.add('section-reviews-moved');
        media.appendChild(rev);
      }
    });
  }

  /* ---------- Offer countdown (real end date only) ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      var box = el.closest('.offer');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { if (box) box.hidden = true; clearInterval(t); return; }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
        var set = function (k, v) { var x = el.querySelector('[data-' + k + ']'); if (x) x.textContent = pad(v); };
        set('d', d); set('h', h); set('m', m); set('s', sec);
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Delivery estimate ---------- */
  function addWorkingDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0, max = parseInt(el.getAttribute('data-max'), 10) || min;
      var now = new Date();
      var fmt = function (d, withMonth) { return d.toLocaleDateString('en-GB', withMonth ? { weekday: 'short', day: 'numeric', month: 'short' } : { weekday: 'short', day: 'numeric' }); };
      var a = addWorkingDays(now, min), b = addWorkingDays(now, max);
      var range = el.querySelector('[data-delivery-range]');
      if (range) range.textContent = (a.getMonth() === b.getMonth() ? fmt(a, false) : fmt(a, true)) + ' – ' + fmt(b, true);
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 0;
      var msg = el.querySelector('[data-cutoff-msg]'), left = el.querySelector('[data-cutoff-left]');
      if (!cutoff || !msg || !left) return;
      function tick() {
        var n = new Date(), c = new Date(n); c.setHours(cutoff, 0, 0, 0);
        var weekday = n.getDay() !== 0 && n.getDay() !== 6;
        var diff = Math.floor((c - n) / 60000);
        if (!weekday || diff <= 0) { msg.hidden = true; return; }
        msg.hidden = false;
        left.textContent = Math.floor(diff / 60) + 'h ' + (diff % 60) + 'm';
      }
      tick(); setInterval(tick, 30000);
    });
  }

  /* ---------- Recommendations ---------- */
  function initReco(root) {
    root.querySelectorAll('[data-reco]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-reco]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; applyPrints(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Cart page + collection sort ---------- */
  function initUpsell(root) {
    var up = root.querySelector('[data-upsell]');
    if (up) {
      var KEY = 'nx_basket_offer_expires', exp = null;
      try { exp = parseInt(localStorage.getItem(KEY), 10) || null; } catch (e) {}
      if (!exp) {
        exp = Date.now() + (parseInt(up.getAttribute('data-minutes'), 10) || 10) * 60000;
        try { localStorage.setItem(KEY, String(exp)); } catch (e) {}
      }
      var mEl = up.querySelector('[data-up-m]'), sEl = up.querySelector('[data-up-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var timer = setInterval(tick, 1000);
      function tick() {
        var left = exp - Date.now();
        if (left <= 0) { up.hidden = true; clearInterval(timer); return; }
        up.hidden = !up.querySelector('.upsell-card');
        mEl.textContent = pad(Math.floor(left / 60000));
        sEl.textContent = pad(Math.floor(left % 60000 / 1000));
      }
      tick();
      up.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-up-add]'); if (!btn) return;
        if (Date.now() > exp) { up.hidden = true; return; }
        var sel = btn.closest('.upsell-card').querySelector('[data-up-variant]');
        if (!sel.value) { sel.classList.add('is-missing'); sel.focus(); return; }
        btn.disabled = true; btn.textContent = '…';
        addToCart(sel.value, 1, { 'Offer': 'Basket offer' }).then(function () { window.location.reload(); })
          .catch(function (err) { btn.disabled = false; btn.textContent = 'Add'; toast(err.message, true); });
      });
      up.addEventListener('change', function (e) { if (e.target.matches('select')) e.target.classList.remove('is-missing'); });
    }
    if (root.querySelector('[data-remove-offers]')) {
      fetch(NX.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) { if (/-basket-offer$/.test(it.handle)) updates[it.key] = 0; });
        if (!Object.keys(updates).length) return;
        return fetch(NX.cartJs.replace(/\.js$/, '/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function () { window.location.reload(); });
      });
    }
  }

  function initCart(root) {
    root.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('[data-qty-input]');
      q.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty'), 10));
          input.form.submit();
        });
      });
      input.addEventListener('change', function () { input.form.submit(); });
    });
    root.querySelectorAll('[data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  function init(root) {
    applyPrints(root);
    initHero(root);
    initProduct(root);
    initReco(root);
    initCart(root);
    initUpsell(root);
    initCountdowns(root);
    initDelivery(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
